import { render, staticRenderFns } from "./Tenement.vue?vue&type=template&id=7fa35b77&scoped=true"
import script from "./Tenement.vue?vue&type=script&lang=js"
export * from "./Tenement.vue?vue&type=script&lang=js"
import style0 from "./Tenement.vue?vue&type=style&index=0&id=7fa35b77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa35b77",
  null
  
)

export default component.exports